import React from "react";

export default function UserPanel (userInfo) {
  return (
    <div className="user-panel">
      <div className='formintro h6'>Account Information</div>
      <div className="formLabel">User Name</div> 
      <div className="user-info">{userInfo?.["cognito:username"]??' '}</div>
      <div className="formLabel">Permission</div>
      <div className="user-info">{userInfo?.["custom:userType"]??' '}</div>
      <div className="formLabel">Email</div>
      <div className="user-info">{userInfo?.email??' '}</div>
      <div className="formLabel">Email Verified</div>
      <div className="user-info">{userInfo?.email_verified?.toString()?? ' '}</div>
    </div>
  )
}
